import Image from '@segment/matcha/components/Image'

import orchestrateTheOutcomesPng2x from './assets/OrchestrateTheOutcomes@2x.png'
import orchestrateTheOutcomesWebp from './assets/OrchestrateTheOutcomes.webp'
import orchestrateTheOutcomesWebp2x from './assets/OrchestrateTheOutcomes@2x.webp'

const OrchestrateTheOutcomesImage = () => {
  return (
    <picture>
      <source type="image/webp" srcSet={`${orchestrateTheOutcomesWebp}, ${orchestrateTheOutcomesWebp2x} 2x`} />
      <Image
        width="399"
        height="369"
        src={orchestrateTheOutcomesPng2x}
        alt="Illustration: Orchestrate the outcomes you want"
        loading="lazy"
      />
    </picture>
  )
}

export default OrchestrateTheOutcomesImage
